<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      scrollable
    >
      <v-card>
        <v-toolbar color="primary" flat>
          <v-toolbar-title class="text--contrast">Оплата</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="text--contrast"
                   icon
                   @click="dialog=null">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="black--text show-scrollbar pt-4 pb-2 pb-sm-4">
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            bottom
            color="primary"
          ></v-progress-linear>

          <v-radio-group @change="changePayFor" hide-details class="mt-0" v-model="payFor">
            <v-radio
              v-if="selectInvoices.length"
              :label="'Оплатить счет'"
              :value="'invoice'"
            ></v-radio>
            <v-radio
              v-if="selectJoins.length"
              :label="'Купить абонемент/оплатить обучение'"
              :value="'join'"
            ></v-radio>
            <v-radio
              v-if="UISettings.onlinePayment.depositOnBalans"
              :label="'Внести сумму на баланс'"
              :value="'balans'"
            ></v-radio>
          </v-radio-group>

          <div class="pt-5" v-if="payFor==='invoice' && selectInvoices.length">
<!--            <h2 v-if="currentDebt === totalDebt" class="body-1">-->
<!--              Сумма: <money color-class="red&#45;&#45;text" :sum="totalDebt"></money>-->
<!--            </h2>-->
<!--            <h2 v-else class="body-1">-->
<!--              Сумма:-->
<!--              <span class="red&#45;&#45;text">{{ currentDebt.toLocaleString(lang) }}</span>-->
<!--              из-->
<!--              <money color-class="red&#45;&#45;text" :sum="totalDebt"></money>-->
<!--            </h2>-->
            <h2 class="body-1">Выберите счет</h2>

            <v-radio-group @change="invoiceChange"
                           required v-model="payload.invoiceId" hide-details>
              <v-radio
                v-for="invoice in selectInvoices"
                :key="invoice.id"
                :value="invoice.id"
              >
                <template slot="label">
                  <div class="d-block">
                    <div>{{ invoice.displayName }}</div>
                    <div class="caption grey--text">
                      <span :class="invoice.payUntilClass">Оплатить до {{ invoice.payUntil }}</span>
                      Счет №{{ invoice.id }}
                    </div>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>

            <!--            <v-text-field-->
            <!--              v-if="partialPaymentForInvoice"-->
            <!--              v-model="payload.summa"-->
            <!--              class="mt-4"-->
            <!--              hide-details-->
            <!--              label="Сумма"-->
            <!--              :placeholder="String(partialPaymentForInvoice)"-->
            <!--              type="number"-->
            <!--              min="1">-->
            <!--            </v-text-field>-->

            <div v-if="showBonuses" class="grey lighten-3 pt-3 pl-2 mb-5 pb-3">
              <h2 class="body-1">
                {{ 'bonuses' | lang }}:
                <money color-class="primary--text" :hide-currency="true" :sum="currentUser.bonusBalance">
                </money>
              </h2>
              <span class="caption grey--text">Можно списать: {{ payload.availableBonuses }}</span>

              <div class="mc-bonuses-block">
                <v-checkbox
                  v-if="currentUser.bonusBalance"
                  v-model="payload.debitBonuses"
                  :label="'Списать бонусы'"
                  hide-details>
                </v-checkbox>

                <v-text-field
                  v-if="payload.debitBonuses"
                  v-model="payload.bonusesSumma"
                  class="mb-2 mc-bonuses-sum"
                  :label="'Сумма'"
                  :placeholder="String(payload.availableBonuses)"
                  type="number"
                  max="payload.availableBonuses"
                  min="0">
                </v-text-field>
              </div>

            </div>

            <div class="grey lighten-3 pt-3 pl-2 mt-5 mb-5 pb-3">
              <h2 class="body-1">
                Баланс:
                <money color-class="primary--text" :sum="currentUser.availableBalance"></money>
              </h2>

              <v-checkbox
                v-if="currentUser.availableBalance"
                v-model="payload.debitFromBalans"
                :label="'Списать средства с баланса'"
                hide-details>
              </v-checkbox>
            </div>

            <h2 class="body-1">
              Итого к оплате:
              <money color-class="primary--text" :sum="totalSum"></money>
            </h2>
          </div>

          <div class="pt-5" v-if="payFor==='join' && selectJoins.length">
            <h2 class="body-1">
              Ваши направления/группы
            </h2>

            <v-radio-group @change="joinChange" required v-model="payload.joinId">
              <v-radio
                v-for="join in selectJoins"
                :key="join.id"
                :label="join.displayName"
                :value="join.id"
              ></v-radio>
            </v-radio-group>

            <h2 v-if="selectSubscriptionTypes.length" class="body-1">
              Выберите абонемент
            </h2>

            <v-select
              v-if="selectSubscriptionTypes.length"
              :items="selectSubscriptionTypes"
              v-model="payload.subscriptionId"
              @change="changeSubscription"
              label="Абонемент"
              item-value="id"
            >
              <template v-slot:selection="{ item }">
                <div class="line-item" style="display: inline">
                  {{ item.displayName }} <v-icon v-if="item.family" size="19">
                    mdi-account-multiple
                  </v-icon>
                </div>
              </template>
              <template v-slot:item="{ item }">
                <div class="line-item" style="display: inline">
                  {{ item.displayName }} <v-icon v-if="item.family" size="19">
                    mdi-account-multiple
                  </v-icon>
                </div>
              </template>
            </v-select>

            <h2 v-if="isShowSubscriptionBeginDateSelect" class="body-1">
              Начало действия абонемента
            </h2>

            <v-radio-group
              v-if="isShowSubscriptionBeginDateSelect"
              required v-model="payload.subscriptionStartDate">
              <v-radio
                :label="'Со следующего месяца'"
                :value="'fromNextMonth'"
              ></v-radio>
              <v-radio
                :label="'С начала текущего месяца'"
                :value="'fromThisMonth'"
              ></v-radio>
              <v-radio
                :label="'С текущей даты'"
                :value="'fromNow'"
              ></v-radio>
            </v-radio-group>

            <h2 class="body-1 mb-5" v-if="joinDiscount">
              Скидка:
              <money color-class="primary--text" :sum="joinDiscount"></money>
            </h2>

            <v-alert outlined type="warning" v-if="maxDiscount && userDiscount >= maxDiscount" class="body-2">
                Максимальная скидка ограничена настройками абонемента/группы в {{ maxDiscount }}%.
            </v-alert>

            <v-text-field
              v-if="subPriceLimits.max && subPriceLimits.min"
              v-model="payload.summa"
              class="mb-2"
              :label="paymentSumLabel"
              :placeholder="String(subPriceLimits.max)"
              type="number"
              min="1">
            </v-text-field>

            <div v-if="showBonuses" class="grey lighten-3 pt-3 pl-2 mb-5 pb-3">
              <h2 class="body-1">
                {{ 'bonuses' | lang }}:
                <money color-class="primary--text" :hide-currency="true" :sum="currentUser.bonusBalance">
                </money>
              </h2>
              <span class="caption grey--text">Можно списать: {{ payload.availableBonuses }}</span>

              <div class="mc-bonuses-block">
                <v-checkbox
                  v-if="currentUser.bonusBalance"
                  v-model="payload.debitBonuses"
                  :label="'Списать бонусы'"
                  hide-details>
                </v-checkbox>

                <v-text-field
                  v-if="payload.debitBonuses"
                  v-model="payload.bonusesSumma"
                  class="mb-2 mc-bonuses-sum"
                  :label="'Сумма'"
                  :placeholder="String(payload.availableBonuses)"
                  type="number"
                  max="payload.availableBonuses"
                  min="0">
                </v-text-field>
              </div>

            </div>

            <div class="grey lighten-3 pt-3 pl-2 mb-5 pb-3">
              <h2 class="body-1">
                Баланс:
                <money color-class="primary--text" :sum="currentUser.availableBalance"></money>
              </h2>

              <v-checkbox
                v-if="currentUser.availableBalance"
                v-model="payload.debitFromBalans"
                :label="'Списать средства с баланса'"
                hide-details>
              </v-checkbox>
            </div>

            <h2 class="body-1">
              Итого к оплате:
              <money color-class="primary--text" :sum="totalSum"></money>
            </h2>
          </div>

           <div class="pt-3"
               v-bind:class="{'pb-2': onlinePaymentIntegrationsSelect
               && onlinePaymentIntegrationsSelect.length > 1 }"
               v-if="payFor==='balans' && UISettings.onlinePayment.depositOnBalans">
            <v-text-field
              v-model="payload.summa"
              label="Сумма"
              type="number"
              hide-details
              min="1">
            </v-text-field>
          </div>

          <v-select
            class="mt-4"
            v-if="onlinePaymentIntegrationsSelect && onlinePaymentIntegrationsSelect.length > 1"
            :items="onlinePaymentIntegrationsSelect"
            v-model="integrationId"
            item-text="name"
            item-value="id"
            hide-details
            label="Платежная система"
          ></v-select>

          <v-alert outlined
                   type="warning"
                   v-if="onlinePaymentIntegrationsSelect && !onlinePaymentIntegrationsSelect.length"
                   class="body-2 mt-4 mb-0">
            Нет подходящей платежной системы. Пожалуйста, обратитесь в вашу школу.
          </v-alert>
        </v-card-text>
        <v-card-actions class="align-center align-center justify-center flex-wrap">
          <v-btn text @click="dialog=null">Отменить</v-btn>
          <v-btn
            :disabled="!formValid || loading"
            @click="createPayment()"
            text
            :class="{'text--secondary':!formValid || loading}"
            class="ml-0 ml-sm-2 accent-btn" color="accent"
          >
            {{ createPaymentBtnText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openLinkDialog" width="500">
      <v-card>
        <v-card-text class="black--text show-scrollbar pt-4 pb-2 pb-sm-4">
          Сейчас вы будете перенаправлены на страницу оплаты.
        </v-card-text>
        <v-card-actions class="align-center align-center justify-center flex-wrap">
          <v-btn color="accent" text @click="closeOpenLink()">ОК</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { isNil } from 'lodash/lang';
import Invoice from '@/api/Invoice';
import Payment from '@/api/Payment';
import { getClassName } from '@/lib/classHelpers';
import loadBaseInfo from '@/lib/baseInfoHelpers';
import { getMoneyStr } from '@/lib/moneyHelpers';
import Money from '@/components/Money';
import { getUserMobileAgent } from '@/lib/mobileHelper';
import { getDisplayName, getSubscriptionForPayment } from '@/lib/subscriptionHelpers';
import { initPaymentProcess } from '@/lib/paymentHelper';

import {
  calculateDiscount,
  getAvailableBonusesSum,
  isValidEntityForBPLevel,
} from '@/lib/bonusProgramHelper';

export default {
  name: 'CreatePaymentDialog',
  components: { Money },
  props: ['value'],
  data: (data) => {
    let payFor = 'invoice';
    const payload = {};

    if (data.value && data.value.payFor) {
      ({ payFor } = data.value);
    }

    if (data.value && data.value.payObjectId) {
      const { payObjectId } = data.value;

      if (payFor === 'invoice') {
        payload.invoiceId = payObjectId;
      }

      if (payFor === 'join') {
        payload.joinId = payObjectId;
      }
    }

    return {
      payFor,
      payload,
      invoices: [],
      totalDebt: 0,
      currentDebt: 0,
      loading: false,
      integrationId: null,
      openLinkDialog: false,
      showBonuses: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return !!this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    bpLevel() {
      const { bpLevel } = this.currentUser;

      if (!bpLevel || !bpLevel.isActive) {
        return null;
      }

      return {
        id: bpLevel.id,
        params: bpLevel.levelParams,
      };
    },
    userDiscount() {
      return this.userDiscounts.discount;
    },
    maxDiscount() {
      return this.userDiscounts.maxDiscount;
    },
    userDiscounts() {
      if (!this.payload.joinId) {
        return { discount: 0 };
      }

      let entity;
      let entityType;

      const discountAttr = this.currentUser.attributes.find(attr => attr.attributeAlias === 'discount');
      const initDiscount = discountAttr ? (+discountAttr.value || 0) : 0;

      const join = this.currentUser.joins.find(el => el.id === this.payload.joinId);
      const cl = this.classes.find(el => el.id === join.classId);

      if (cl.payType === 'full') {
        entity = cl;
        entityType = 'class';
      } else if (!this.payload.subscriptionId) {
        return { discount: 0 };
      } else if (this.payload.subscriptionId) {
        const subType = this.subscriptionTypes
          .find(s => s.id === this.payload.subscriptionId);

        entity = subType;
        entityType = 'sub';
      }

      const { discount, maxDiscount } = calculateDiscount({
        entityType,
        entity,
        initDiscount,
        level: this.bpLevel,
      });

      return { discount, maxDiscount };
    },
    paymentSumLabel() {
      const minStr = this.subPriceLimits.min.toLocaleString(this.lang);
      const maxStr = getMoneyStr(this.subPriceLimits.max);
      return `Сумма оплаты (от ${minStr} до ${maxStr})`;
    },
    priceForJoin() {
      if (!this.payload.joinId) {
        return 0;
      }

      const join = this.currentUser.joins.find(j => j.id === this.payload.joinId);
      const cl = this.classes.find(c => c.id === join.classId);

      if (cl.payType === 'full') {
        return join.price;
      }

      if (this.payload.subscriptionId) {
        const subType = this.subscriptionTypes
          .find(s => s.id === this.payload.subscriptionId);
        const allowedSubscriptionTypeIds = this.getSubscriptionTypesForClass(cl.id).map(s => s.id);
        if (!allowedSubscriptionTypeIds.includes(subType.id)) return 0;

        const filial = this.filials.find(el => el.id === cl.filialId);
        const sub = getSubscriptionForPayment(subType, filial);

        return sub.price;
      }

      return 0;
    },
    joinDiscount() {
      if (!this.payload.joinId) {
        return 0;
      }

      const join = this.currentUser.joins.find(j => j.id === this.payload.joinId);
      const cl = this.classes.find(c => c.id === join.classId);

      if (cl.payType === 'full') {
        return undefined;
      }

      if (this.userDiscount === 100) {
        return 0;
      }

      if (this.payload.subscriptionId && cl.useDiscount && this.userDiscount) {
        return Math.round(this.priceForJoin * (this.userDiscount) / 100);
      }

      return 0;
    },
    partialPaymentForInvoice() {
      if (!this.payload.invoiceId) {
        return null;
      }

      const invoice = this.invoices.find(i => i.id === this.payload.invoiceId);

      if (!invoice) {
        return null;
      }

      let classId;


      if (invoice.joinId) {
        const join = this.currentUser.joins.find(j => j.id === invoice.joinId);
        if (!join) {
          return null;
        }

        ({ classId } = join);
      } else if (invoice.userSubscriptionId) {
        const userSub = this.userSubscriptions.find(us => us.id === invoice.userSubscriptionId);
        if (!userSub) {
          return null;
        }

        ({ mainClassId: classId } = userSub);
      }

      const cl = this.classes.find(c => c.id === classId);
      if (!cl) {
        return null;
      }

      if (!cl.onlinePayment.partialPaymentForDebt) {
        return null;
      }

      return invoice.needToPay;
    },
    subPriceLimits() {
      if (!this.payload.subscriptionId || !this.payload.joinId) {
        return {};
      }

      const join = this.currentUser.joins.find(j => j.id === this.payload.joinId);
      if (!join) {
        return {};
      }

      const cl = this.classes.find(c => c.id === join.classId);
      if (!cl || cl.payType === 'full') {
        return {};
      }

      const subType = this.getSubscriptionTypesForClass(cl.id)
        .find(({ id }) => id === this.payload.subscriptionId);

      if (!subType) {
        return {};
      }

      const result = {
        max: this.priceForJoin - this.joinDiscount,
      };

      const { partialPaymentForNewJoinMin, partialPaymentForNewJoin } = cl.onlinePayment;

      if (partialPaymentForNewJoin) {
        result.min = Math.round(result.max * +partialPaymentForNewJoinMin / 100);
      } else {
        return {};
      }

      return result;
    },
    selectInvoices() {
      if (!this.invoices) {
        return [];
      }

      return this.invoices
        .map((invoice) => {
          invoice.needToPay = invoice.nextSum || invoice.price - invoice.payed;

          if (invoice.nextSum && invoice.nextSum !== invoice.price - invoice.payed) {
            invoice.displayName = `${invoice.needToPay.toLocaleString(this.lang)} из ${getMoneyStr(invoice.price - invoice.payed)}`;
          } else {
            invoice.displayName = `${getMoneyStr(invoice.needToPay)}`;
          }

          if (invoice.userSubscriptionId) {
            const sub = this.userSubscriptions.find(us => us.id === invoice.userSubscriptionId);
            if (sub) {
              invoice.displayName += ` - Аб. №${sub.id} ${getClassName(sub.mainClassId)}`;
            }
          }
          if (invoice.joinId) {
            const join = this.currentUser.joins.find(j => j.id === invoice.joinId);
            if (join) {
              invoice.displayName += ` - ${getClassName(join.classId)}`;
            }
          }

          if (invoice.payUntil) {
            const diff = -moment().diff(invoice.payUntil, 'day');
            invoice.payUntilClass = null;
            if (diff < 0) {
              invoice.payUntilClass = 'red--text';
            }
            invoice.payUntil = moment(invoice.payUntil).format('DD/MM/YYYY');
          }

          return invoice;
        })
        .filter(Boolean);
    },
    selectJoins() {
      return this.currentUser.joins
        .map((join) => {
          const cl = this.classes.find(c => c.id === join.classId);

          if (!cl || !cl.onlinePayment.enabled) {
            return null;
          }

          if (join.invoices.length) {
            return null;
          }

          if (join.status === 'over') {
            return null;
          }

          join.displayName = getClassName(cl.id).trim();

          if (cl.payType === 'full') {
            join.displayName += ` - ${getMoneyStr(join.price)}`;
          } else {
            const subscriptionTypes = this.getSubscriptionTypesForClass(cl.id);

            if (!subscriptionTypes.length) {
              return null;
            }
          }

          return join;
        })
        .filter(Boolean)
        .sort((a, b) => (a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1));
    },
    selectSubscriptionTypes() {
      if (!this.payload.joinId) {
        return [];
      }

      const join = this.currentUser.joins.find(j => j.id === this.payload.joinId);
      if (!join) {
        return [];
      }

      return this.getSubscriptionTypesForClass(join.classId);
    },
    isShowSubscriptionBeginDateSelect() {
      if (!this.payload.joinId || !this.payload.subscriptionId) {
        return false;
      }

      const subscriptionType = this.subscriptionTypes
        .find(s => s.id === this.payload.subscriptionId);

      return subscriptionType ? subscriptionType.onlinePayment.beginDateSelectEnabled : false;
    },
    totalSum() {
      const {
        bonusesSumma,
        debitBonuses,
      } = this.payload;

      const bonuses = debitBonuses ? +bonusesSumma || 0 : 0;
      if (this.payFor === 'invoice' && this.payload.invoiceId) {
        const invoice = this.invoices.find(i => i.id === this.payload.invoiceId);

        let { needToPay } = invoice;

        needToPay -= bonuses;

        if (this.partialPaymentForInvoice && this.payload.summa) {
          needToPay = this.payload.summa;
        }

        if (!this.payload.debitFromBalans) {
          return needToPay;
        }

        return this.currentUser.availableBalance > needToPay ? 0
          : needToPay - this.currentUser.availableBalance;
      }

      if (this.payFor === 'join' && this.payload.joinId) {
        let resultPrice = this.priceForJoin - (this.joinDiscount || 0);

        if (debitBonuses) {
          resultPrice = resultPrice - bonuses > 0 ? resultPrice - bonuses : 0;
        }

        if (this.payload.summa) {
          resultPrice = +this.payload.summa;
        }

        if (!this.payload.debitFromBalans) {
          return resultPrice;
        }

        return this.currentUser.availableBalance > resultPrice ? 0
          : resultPrice - this.currentUser.availableBalance;
      }

      return 0;
    },
    formValid() {
      if (!this.integrationId) {
        return false;
      }

      if (this.payFor === 'invoice' && this.payload.invoiceId) {
        const invoice = this.invoices.find(i => i.id === this.payload.invoiceId);

        if (this.payload.debitBonuses && this.payload.bonusesSumma > this.payload.availableBonuses) {
          return false;
        }

        if (this.partialPaymentForInvoice && this.payload.summa) {
          return this.payload.summa <= invoice.needToPay && this.payload.summa > 0;
        }

        return true;
      }

      if (this.payFor === 'join' && this.payload.joinId) {
        const join = this.currentUser.joins.find(j => j.id === this.payload.joinId);
        if (!join) {
          return false;
        }

        const cl = this.classes.find(c => c.id === join.classId);
        if (!cl || cl.payType === 'full') {
          return true;
        }

        let isSumValid = true;

        if (this.payload.summa) {
          isSumValid = this.payload.summa >= this.subPriceLimits.min
            && this.payload.summa <= this.subPriceLimits.max;
        }

        const subscriptionTypeIds = this.getSubscriptionTypesForClass(cl.id).map(s => s.id);

        const isSubStartDate = this.isShowSubscriptionBeginDateSelect
          ? !!this.payload.subscriptionStartDate : true;

        if (this.payload.debitBonuses
          && this.payload.bonusesSumma > this.payload.availableBonuses) {
          return false;
        }

        return isSumValid
          && subscriptionTypeIds.includes(this.payload.subscriptionId) && isSubStartDate;
      }

      if (this.payFor === 'balans') {
        return this.payload.summa > 0;
      }

      return false;
    },
    createPaymentBtnText() {
      if (this.formValid && this.payload.debitFromBalans && this.totalSum === 0) {
        return 'Списать средства с баланса';
      }

      if (this.formValid && this.payload.debitFromBalans && this.totalSum > 0) {
        return 'Списать и перейти к оплате';
      }

      return 'Перейти к оплате';
    },
    onlinePaymentIntegrationsSelect() {
      let classId;

      if (this.payFor === 'invoice' && this.payload.invoiceId) {
        const invoice = this.invoices.find(i => i.id === this.payload.invoiceId);
        if (!invoice) {
          return null;
        }

        if (invoice.userSubscriptionId) {
          const sub = this.userSubscriptions.find(us => us.id === invoice.userSubscriptionId);
          if (!sub) {
            return null;
          }

          classId = sub.mainClassId;
        }
        if (invoice.joinId) {
          const join = this.currentUser.joins.find(j => j.id === invoice.joinId);
          if (!join) {
            return null;
          }

          ({ classId } = join);
        }
      }

      if (this.payFor === 'join' && this.payload.joinId) {
        const join = this.currentUser.joins.find(j => j.id === this.payload.joinId);
        if (!join) {
          return null;
        }

        ({ classId } = join);
      }

      if (this.payFor !== 'balans' && !classId) {
        return null;
      }

      const sortFunc = (a, b) => (a.name > b.name ? 1 : -1);

      if (this.payFor !== 'balans') {
        const cl = this.classes.find(c => c.id === classId);
        if (!cl) {
          return null;
        }

        return this.onlinePaymentIntegrations
          .filter(({ filialIds }) => filialIds.includes(0) || filialIds.includes(cl.filialId))
          .sort(sortFunc);
      }

      return this.onlinePaymentIntegrations
        .filter(({ filialIds }) => filialIds.includes(0)
          || filialIds.filter(value => this.currentUser.filials.includes(value)).length)
        .sort(sortFunc);
    },
    ...mapGetters(['currentUser', 'UISettings', 'lang', 'classes', 'filials', 'userSubscriptions', 'subscriptionTypes', 'onlinePaymentIntegrations', 'allowedClassIds']),
  },
  methods: {
    clearBpPayloadData() {
      this.$set(this.payload, 'debitBonuses', null);
      this.$set(this.payload, 'availableBonuses', null);
      this.$set(this.payload, 'bonusesSumma', null);
      this.showBonuses = false;
    },
    calculateBonuses(entity, entityType) {
      let price;
      let initPrice;
      let bonusesPaid = 0;

      // Если покупаем новое
      if (!this.payload.invoiceId) {
        if (entityType === 'sub') {
          price = !isNil(this.subPriceLimits.max)
            ? this.subPriceLimits.max
            : this.priceForJoin - (this.priceForJoin * (this.userDiscount) / 100);
        }

        if (entityType === 'class') {
          price = this.priceForJoin;
        }

        initPrice = price;
      } else {
        const invoices = this.getInvoicesByPayload();
        price = invoices.reduce((acc, invoice) => acc + (invoice.price || 0) - (invoice.payed || 0), 0);
        initPrice = invoices.reduce((acc, invoice) => acc + invoice.price, 0);
        bonusesPaid = invoices.reduce((acc, invoice) => acc + (invoice.payedBonuses || 0), 0);
      }

      const availableBonuses = getAvailableBonusesSum({
        entity,
        entityType,
        level: this.bpLevel,
        balance: this.currentUser.bonusBalance,
        bonusesPaid,
        price,
        initPrice,
      });

      this.payload.availableBonuses = availableBonuses;
      this.payload.bonusesSumma = availableBonuses;
    },
    getInvoicesByPayload() {
      let invoices;

      const invoice = this.invoices.find(el => el.id === this.payload.invoiceId);
      if (invoice.userSubscriptionId) {
        invoices = this.invoices.filter(el => el.userSubscriptionId === invoice.userSubscriptionId);
      }

      if (invoice.joinId) {
        invoices = this.invoices.filter(el => el.joinId === invoice.joinId);
      }

      return invoices;
    },
    getBpEntityData() {
      if (this.payload.subscriptionId) {
        const sub = this.subscriptionTypes.find(el => el.id === this.payload.subscriptionId);
        return { entityType: 'sub', entity: sub };
      } if (this.payload.invoiceId) {
        const invoice = this.invoices.find(el => el.id === this.payload.invoiceId);
        if (invoice.joinId) {
          const join = this.currentUser.joins.find(el => el.id === invoice.joinId);
          const cl = this.classes.find(el => el.id === join.classId);
          return { entityType: 'class', entity: cl };
        }

        if (invoice.userSubscriptionId) {
          const userSub = this.userSubscriptions.find(el => el.id === invoice.userSubscriptionId);
          const subType = this.subscriptionTypes.find(el => el.id === userSub.subscriptionId);
          return { entityType: 'sub', entity: subType };
        }
      }

      return {};
    },
    showBonusesBlock() {
      if (!this.currentUser) {
        return false;
      }

      const { bpLevel } = this.currentUser;

      if (!(bpLevel && bpLevel.isActive)) {
        return false;
      }

      const { entityType, entity } = this.getBpEntityData();

      if (!entityType || !entity) {
        return false;
      }

      const isValid = isValidEntityForBPLevel({
        entityType,
        entity,
        level: this.bpLevel,
        operationType: 'points',
      });

      if (!isValid) {
        return false;
      }

      this.calculateBonuses(entity, entityType);

      return isValid;
    },
    changePayFor() {
      this.clearBpPayloadData();
      this.payload = {};

      if (this.payFor === 'join') {
        this.payload.subscriptionStartDate = 'fromNow';
      }

      this.setDefaultIntegration();
    },
    changeSubscription() {
      this.clearBpPayloadData();
      this.showBonuses = this.showBonusesBlock();
    },
    async closeOpenLink() {
      await loadBaseInfo();
      this.openLinkDialog = false;
      this.dialog = null;
    },
    async createPayment() {
      this.loading = true;

      const paymentData = {
        userId: this.currentUser.id,
        integrationId: this.integrationId,
      };

      if (this.payFor === 'invoice') {
        paymentData.payload = {
          payFor: 'invoice',
          invoiceId: this.payload.invoiceId,
          debitFromBalans: !!this.payload.debitFromBalans,
          debitBonuses: !!this.payload.debitBonuses,
          summa: this.payload.summa ? +this.payload.summa : undefined,
        };

        if (this.payload.debitBonuses) {
          paymentData.payload.bonusesSumma = this.payload.bonusesSumma;
        }
      }

      if (this.payFor === 'balans') {
        paymentData.payload = {
          payFor: 'balans',
          summa: +this.payload.summa,
        };
      }

      if (this.payFor === 'join') {
        const join = this.currentUser.joins.find(j => j.id === this.payload.joinId);
        if (!join) {
          return;
        }
        const subTypes = this.getSubscriptionTypesForClass(join.classId);
        paymentData.payload = {
          summa: this.payload.summa ? +this.payload.summa : undefined,
          joinId: this.payload.joinId,
          subscriptionId: this.payload.subscriptionId,
          subscriptionStartDate: this.payload.subscriptionStartDate,
          debitFromBalans: !!this.payload.debitFromBalans,
          debitBonuses: !!this.payload.debitBonuses,
          payFor: subTypes.length ? 'subForExistingJoin' : 'existingJoin',
        };

        if (this.payload.debitBonuses) {
          paymentData.payload.bonusesSumma = this.payload.bonusesSumma;
        }

        const sub = subTypes.find(el => el.id === this.payload.subscriptionId);
        if (sub && sub.type === 'dynamic') {
          const cl = this.classes.find(c => c.id === join.classId);
          const filial = this.filials.find(el => el.id === cl.filialId);
          const updatedSub = getSubscriptionForPayment(sub, filial);
          paymentData.payload.subscriptionVisitCount = updatedSub.visitCount;
        }
      }

      if (window.ReactNativeWebView) {
        paymentData.payload.platform = getUserMobileAgent();
      }

      try {
        const { data } = await Payment.create(paymentData);

        if (data.result) {
          if (data.paymentProcessType === 'none') {
            this.setSnackInfoMessage('Оплата прошла успешно');
          } else {
            if (data.paymentProcessType === 'redirect' && window.ReactNativeWebView) {
              this.openLinkDialog = true;
            }
            await initPaymentProcess(data);
          }
        } else if (data.error && data.error.message) {
          this.setSnackInfoMessage(data.error.message);
        } else {
          this.setSnackErrorMessage('Не удалось создать оплату. Пожалуйста, обновите страницу');
        }
      } catch (e) {
        if (e.response && e.response.data
          && e.response.data.error && e.response.data.error.message) {
          this.setSnackErrorMessage(e.response.data.error.message);
        } else {
          this.setSnackErrorMessage('Оплата невозможна. Пожалуйста, обновите страницу');
        }
      }

      await loadBaseInfo();

      this.loading = false;
      if (!this.openLinkDialog) {
        this.dialog = null;
      }
    },
    async loadInvoices() {
      if (this.currentUser) {
        this.loading = true;

        // Если для юзера нет классов, в которых разрешено отображение в ЛК,
        // значит не нужно показывать счета этого юзера
        if (!this.allowedClassIds.length) {
          this.invoices = [];
          this.loading = false;
          return;
        }

        const result = await Invoice.fetch({
          userId: this.currentUser.id,
          remainSum: [1, 9999999999],
          classId: this.allowedClassIds,
        });

        this.invoices = result.data.invoices;
        this.totalDebt = result.data.stats.totalDebt;
        this.currentDebt = result.data.stats.currentDebt;

        this.loading = false;
      }
    },
    getSubscriptionTypesForClass(classId) {
      const cl = this.classes.find(c => c.id === classId);
      if (!cl || cl.payType === 'full') {
        return [];
      }

      const { subscriptionIds } = cl.onlinePayment;

      const enabledSubs = this.subscriptionTypes.filter((sub) => {
        const byFilial = sub.filialIds.includes(cl.filialId) || sub.filialIds.includes(0);
        // Если мультиабонемент, то не сортируем по курсам
        if ((sub.courses && sub.courses.length) || (sub.classes && sub.classes.length)) {
          return byFilial && ((sub.courses.indexOf(-1) !== -1
            || sub.courses.indexOf(cl.courseId) !== -1
            || sub.classes.indexOf(cl.id) !== -1));
        }

        const { courseIds, classIds } = sub.onlinePayment;

        return byFilial && (courseIds.includes(-1) || courseIds.indexOf(cl.courseId) !== -1
          || classIds.indexOf(cl.id) !== -1);
      });
      const filial = this.filials.find(el => el.id === cl.filialId);
      return enabledSubs
        .filter(sub => subscriptionIds.includes(sub.id) || subscriptionIds.includes(-1))
        .map((sub) => {
          sub.displayName = getDisplayName(sub, filial);
          return sub;
        })
        .sort((a, b) => (a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1));
    },
    setDefaultSubscription() {
      if (this.selectSubscriptionTypes && this.selectSubscriptionTypes.length === 1) {
        this.payload.subscriptionId = this.selectSubscriptionTypes[0].id;
      } else {
        delete this.payload.subscriptionId;
      }
    },
    setDefaultIntegration() {
      if (this.onlinePaymentIntegrationsSelect
        && this.onlinePaymentIntegrationsSelect.length === 1) {
        this.integrationId = this.onlinePaymentIntegrationsSelect[0].id;
      }
    },
    joinChange() {
      this.clearBpPayloadData();
      this.setDefaultIntegration();
      this.setDefaultSubscription();
    },
    invoiceChange() {
      this.setDefaultIntegration();
      this.clearBpPayloadData();
      this.showBonuses = this.showBonusesBlock();
    },
    ...mapMutations(['setSnackInfoMessage', 'setSnackErrorMessage']),
  },
  async created() {
    this.setDefaultSubscription();
    await this.loadInvoices();
    this.setDefaultIntegration();
  },
};
</script>

<style>

.line-item {
  line-height: 1.5;
  padding-top: 5px;
  padding-bottom: 5px;
}

div[role="listbox"] {
  max-width: 500px;
}

.v-select .v-select__selections input {
  display: none !important;
}

.mc-bonuses-block {
  display: flex;
  flex-direction: row;

  .mc-bonuses-sum {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 549px) {
    flex-direction: column;

    .mc-bonuses-sum {
      padding-left:  8px;
      padding-right: 8px;
    }
  }
}

</style>
